import { useEffect } from "react";
import { useTheme } from "@mui/material";
import { setCache } from "components/common/Utils/cacheUtil";
import LookupAPI from "../api/lookupDataApi";
import { WorkOrder } from "../models/workOrderTypes";
import { useWorkOrderStore } from "../../store/zustandWorkOrderStore";
import {
  getWorkOrderStatusColors,
  woStatusesHaveColors,
  WoStatusWithColors,
} from "./workOrderStatusStyle";

export const useWorkOrderStatusColors = (workOrder: WorkOrder) => {
  const theme = useTheme();
  const woStatuses = useWorkOrderStore(
    (state) => state.woStatuses,
  ) as WoStatusWithColors[];
  const setWoStatusLookup = useWorkOrderStore(
    (state) => state.setWoStatusLookup,
  );

  useEffect(() => {
    if (woStatuses.length === 0 || woStatusesHaveColors(woStatuses)) {
      return;
    }

    const username = localStorage.getItem("username") || "";
    localStorage.removeItem(`WorkOrderStatuses_${username}`);

    void LookupAPI.getWorkOrderStatuses().then((data) => {
      if (!data?.length || !woStatusesHaveColors(data as WoStatusWithColors[])) {
        return;
      }

      setCache("WorkOrderStatuses", data, username);
      setWoStatusLookup(data);
    });
  }, [woStatuses, setWoStatusLookup]);

  return getWorkOrderStatusColors(workOrder, woStatuses, theme);
};
